import {
  makeStyles,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '35vw'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  }
}))

const ReferenciaObservacaoDialogContent = ({ refComercial, handleClose }) => {
  const classes = useStyles()

  return (
    <Box p={2} className={classes.root}>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography align="center" variant="h5">
            Referência Comercial: {refComercial?.nome}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            multiline
            minRows={4}
            maxRows={8}
            fullWidth
            value={refComercial?.observacao}
            InputProps={{
              readOnly: true
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReferenciaObservacaoDialogContent
